export enum ObjectDisplay {
  id,
  label,
  full
}
